import type { MessageDescriptor } from "@lingui/core";
import { msg } from "@lingui/core/macro";
import { Crown, ShieldCheck, User, type LucideIcon } from "lucide-react";
import type { OrgRole } from "@ando/core";

/**
 * Single source of truth for org-role DISPLAY (label + icon), shared by the
 * customer-facing Settings members panel and the operator Admin tabs so the
 * role vocabulary cannot drift between them. Labels are localized via Lingui.
 *
 * NOTE: the developer Console surface (features/console/StatusBadges) keeps its
 * own product-specific vocabulary by deliberate choice; unifying the two is a
 * product decision tracked separately — do NOT touch console here.
 */
export const ROLE_LABEL: Record<OrgRole, MessageDescriptor> = {
  owner: msg`Proprietario`,
  admin: msg`Amministratore`,
  member: msg`Membro`,
};

export const ROLE_ICON: Record<OrgRole, LucideIcon> = {
  owner: Crown,
  admin: ShieldCheck,
  member: User,
};
